<template>
  <div class="hamburguer-menu" ref="menuContainer">
    <button
      class="menu-button"
      @click="toggleMenu"
    >
      MENU
      <span class="menu-dots">
        <span class="dot"></span>
        <span class="dot"></span>
      </span>
    </button>
    <transition
      @enter="onEnter"
      @leave="onLeave"
      :css="false"
    >
      <div v-if="isMenuOpen" class="dropdown-menu">
        <div class="menu-item" @click="navigateTo('Home')">Home</div>
        <div class="menu-item" @click="navigateTo('About Us')">About Us</div>
        <div class="menu-item" @click="navigateTo('Projects')">Projects</div>
        <div class="menu-item" @click="navigateTo('Contact')">Contact</div>
      </div>
    </transition>
  </div>
</template>

<script>
import gsap from 'gsap';

export default {
  name: 'HamburguerMenu',
  data() {
    return {
      isMenuOpen: false
    };
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    navigateTo(item) {
      console.log(`Navigating to: ${item}`);
      this.isMenuOpen = false;
    },
    handleClickOutside(event) {
      if (this.$refs.menuContainer && !this.$refs.menuContainer.contains(event.target)) {
        this.isMenuOpen = false;
      }
    },
    onEnter(el, done) {
      gsap.fromTo(
        el,
        { opacity: 0, xPercent: -50, y: 24, rotation: 4 },
        { opacity: 1, xPercent: -50, y: 0, rotation: 0, duration: 0.2, ease: 'power2.out', onComplete: done }
      );
    },
    onLeave(el, done) {
      gsap.to(el, {
        opacity: 0,
        xPercent: -50,
        y: 24,
        rotation: 4,
        duration: 0.3,
        ease: 'power2.in',
        onComplete: done
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.hamburguer-menu {
  position: relative;
  width: 100%;
  height: 100vh;
}

.menu-button {
  position: absolute;
  top: 40px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 92px;
  height: 40px;
  border-radius: 78px;
  background-color: #333333;
  color: white;
  border: none;
  font-weight: bold;
  font-size: 12px;
  cursor: pointer;
  z-index: 1001;
  transition: background-color 0.3s ease, color 0.3s ease;

  &:hover {
    background-color: white;
    color: #333333;

    .menu-dots {
      transform: rotate(90deg);

      .dot {
        background-color: #333333;
      }
    }
  }
}

.menu-dots {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 3px;
  transition: transform 0.3s ease;

  .dot {
    width: 3.5px;
    height: 3.5px;
    border-radius: 50%;
    background-color: white;
    flex-shrink: 0;
    transition: background-color 0.3s ease;
  }
}

.dropdown-menu {
  position: absolute;
  top: 88px; /* 40px top + 40px button height + 8px gap */
  left: 50%;
  background-color: white;
  border-radius: 8px;
  padding: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 160px;
}

.menu-item {
  padding: 14px 24px;
  height: 52px;
  box-sizing: border-box;
  color: black;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-size: 14px;
  text-transform: uppercase;
  text-align: left;

  &:hover {
    background-color: #f5f5f5;
  }

  &:first-child {
    border-radius: 8px 8px 0 0;
  }

  &:last-child {
    border-radius: 0 0 8px 8px;
  }
}
</style>
